import {
    createFileRoute,
} from '@tanstack/react-router'

import {
    AddUserPage,
} from '@/features/users/pages/add-user-page'

export const Route =
    createFileRoute(
        '/_authenticated/users/new',
    )({
        component: AddUserPage,
    })